import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-13547ed8"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "register"
};
var _hoisted_2 = {
  class: "register-wrapper"
};
var _hoisted_3 = {
  class: "form-wrapper"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", null, "注册账号", -1);
});

var _hoisted_5 = {
  key: 0,
  class: "corp-name"
};

var _hoisted_6 = /*#__PURE__*/_createTextVNode(" 注册后将自动加入 ");

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" 企业 ");

var _hoisted_8 = {
  class: "password-tip"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconmengban"
  }, null, -1);
});

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "至少 8 个字符", -1);
});

var _hoisted_11 = [_hoisted_9, _hoisted_10];

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconmengban"
  }, null, -1);
});

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "需同时包含大小写字母、特殊字符及数字", -1);
});

var _hoisted_14 = [_hoisted_12, _hoisted_13];

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "phone-start"
  }, "+ 86", -1);
});

var _hoisted_16 = {
  key: 0,
  class: "normal-tip"
};

var _hoisted_17 = /*#__PURE__*/_createTextVNode("我已阅读并同意 ");

var _hoisted_18 = {
  key: 0
};
var _hoisted_19 = ["href"];

var _hoisted_20 = /*#__PURE__*/_createTextVNode(" 及");

var _hoisted_21 = ["href"];
var _hoisted_22 = {
  key: 0,
  class: "link-wrap"
};

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "已有账号？", -1);
});

var _hoisted_24 = /*#__PURE__*/_createTextVNode("去登录");

import { ElMessage } from 'element-plus';
import { reactive, ref, onMounted } from 'vue';
import UserService from '@/api/user';
import { useRoute, useRouter } from 'vue-router';
import { loginTip, registerTip } from '@/config/constant';
import { checkEmail, checkPassword, checkPasswordStatus, checkRepeatPassword, checkPhone, checkVerifyCode } from '@/utils/validate';
import { setStoreState } from '@/store/utils';
import { getAuthRedirectUrl, getUrlQuery, genHrefOpenUrl } from '@/utils/login';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var formRef = ref();
    var nameError = ref('');
    var pwdError = ref('');
    var corpName = ref('');
    var fullNameError = ref('');
    var repeatPwdError = ref('');
    var phoneError = ref('');
    var verifyCodeError = ref('');
    var bindCode = ref('');
    var corpInviteCode = ref('');
    var passwordType = ref('password');
    var repeatPasswordType = ref('password');
    var hasSentCode = ref(false);
    var verifyCodeTimer = ref(60);
    var formState = reactive({
      name: '',
      password: '',
      repeatPassword: '',
      phone: '',
      verifyCode: '',
      fullName: '',
      agreementChecked: false
    });
    var _window$AppConfig$reg = window.AppConfig.register,
        forceBind = _window$AppConfig$reg.forceBind,
        _window$AppConfig$reg2 = _window$AppConfig$reg.serviceProtocol,
        serviceProtocol = _window$AppConfig$reg2 === void 0 ? '' : _window$AppConfig$reg2,
        _window$AppConfig$reg3 = _window$AppConfig$reg.privacyProtocol,
        privacyProtocol = _window$AppConfig$reg3 === void 0 ? '' : _window$AppConfig$reg3;
    var submitText = forceBind ? '去扫码绑定' : '注册'; // 校验邮箱

    var validateName = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                nameError.value = checkEmail(value.trim());
                nameError.value ? callback(nameError.value) : callback();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function validateName(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }(); // 校验密码


    var validateFullName = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fullNameError.value = !value ? loginTip.fullNameEmpty : '';
                fullNameError.value ? callback(fullNameError.value) : callback();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function validateFullName(_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }(); // 校验密码


    var validatePassword = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                pwdError.value = checkPassword(value);
                pwdError.value ? callback(pwdError.value) : callback();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function validatePassword(_x7, _x8, _x9) {
        return _ref3.apply(this, arguments);
      };
    }(); // 校验确认密码


    var validateRepeatPassword = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                repeatPwdError.value = checkRepeatPassword(value, formState.password);
                repeatPwdError.value ? callback(repeatPwdError.value) : callback();

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function validateRepeatPassword(_x10, _x11, _x12) {
        return _ref4.apply(this, arguments);
      };
    }(); // 校验手机号


    var validatePhone = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                phoneError.value = checkPhone(value.trim(), false);
                phoneError.value ? callback(phoneError.value) : callback();

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function validatePhone(_x13, _x14, _x15) {
        return _ref5.apply(this, arguments);
      };
    }(); // 校验验证码


    var validateVerifyCode = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                verifyCodeError.value = checkVerifyCode(value.trim());
                verifyCodeError.value ? callback(verifyCodeError.value) : callback();

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function validateVerifyCode(_x16, _x17, _x18) {
        return _ref6.apply(this, arguments);
      };
    }();

    var validatePasswordStatus = function validatePasswordStatus() {
      return checkPasswordStatus(formState.password);
    }; // 校验规则


    var rules = {
      name: [{
        validator: validateName,
        trigger: 'blur'
      }],
      password: [{
        validator: validatePassword,
        trigger: 'blur'
      }],
      repeatPassword: [{
        validator: validateRepeatPassword,
        trigger: 'blur'
      }],
      phone: [{
        validator: validatePhone,
        trigger: 'blur'
      }],
      verifyCode: [{
        validator: validateVerifyCode,
        trigger: 'blur'
      }]
    }; // tob: 注册 & 微信登陆后再注册

    var register = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _route$query, login_req_key, user_info_key, params, loginRes, _loginRes$data, code, msg, result, status, redirectUrl;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _route$query = route.query, login_req_key = _route$query.login_req_key, user_info_key = _route$query.user_info_key;
                params = {
                  email: formState.name.trim(),
                  password: formState.password,
                  user_name: formState.fullName,
                  phone: formState.phone.trim(),
                  verification_code: (formState.verifyCode || '').trim(),
                  // 微信扫码后端生成的key，微信扫码后端跳转到前端注册页的时候会带回此参数，此场景下前端调注册接口时需传入此参数
                  login_req_key: (login_req_key === null || login_req_key === void 0 ? void 0 : login_req_key.toString()) || '',
                  // 微信用户信息key，微信扫码后端跳转到前端注册页的时候会带回此参数，此场景下前端调注册接口时需传入此参数
                  user_info_key: (user_info_key === null || user_info_key === void 0 ? void 0 : user_info_key.toString()) || '',
                  department: '',
                  data_auth_redirect_url: getAuthRedirectUrl(route.query),
                  // 微信扫码回调跳转到前端的账密绑定页，账密注册后扫码绑定微信需要用到
                  ap_bind_redirect_url: "".concat(location.origin, "/account/bind"),
                  corp_invitation_code: corpInviteCode.value || ''
                }; // 注册时同时执行绑定（从微信扫码登陆过来）

                _context7.next = 4;
                return UserService.register(params);

              case 4:
                loginRes = _context7.sent;
                _loginRes$data = loginRes === null || loginRes === void 0 ? void 0 : loginRes.data, code = _loginRes$data.code, msg = _loginRes$data.msg, result = _loginRes$data.result;
                setStoreState('user', 'isLogin', code === 1);

                if (code === 1) {
                  status = result.status, redirectUrl = result.redirectUrl; // 1-直接账密注册返回，2-微信扫码后账密注册返回

                  ElMessage({
                    message: status === 2 ? loginTip.registerBindWxSuccess : registerTip['0'],
                    type: 'success'
                  });

                  if (status === 1) {
                    // 注册后未绑定微信，提示绑定微信
                    router.push("/wxlogin?haslogin=1&key=".concat(result.key, "&redirect_url=").concat(encodeURIComponent(redirectUrl)));
                  } else {
                    location.href = decodeURIComponent(genHrefOpenUrl(redirectUrl));
                  }
                } else {
                  ElMessage({
                    message: msg,
                    type: 'error'
                  });
                }

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function register() {
        return _ref7.apply(this, arguments);
      };
    }(); // 外网：去扫码绑定


    var goBind = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _route$query2, login_req_key, user_info_key, params, loginRes, _loginRes$data2, code, msg, result;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _route$query2 = route.query, login_req_key = _route$query2.login_req_key, user_info_key = _route$query2.user_info_key;
                params = {
                  email: formState.name.trim(),
                  password: formState.password,
                  user_name: formState.fullName,
                  phone: formState.phone.trim(),
                  verification_code: (formState.verifyCode || '').trim(),
                  data_auth_redirect_url: getAuthRedirectUrl(route.query),
                  ap_bind_redirect_url: "".concat(location.origin, "/wxlogin"),
                  corp_invitation_code: corpInviteCode.value || ''
                }; // 注册时同时执行绑定（从微信扫码登陆过来）

                _context8.next = 4;
                return UserService.submitRegisterInfo(params);

              case 4:
                loginRes = _context8.sent;
                _loginRes$data2 = loginRes === null || loginRes === void 0 ? void 0 : loginRes.data, code = _loginRes$data2.code, msg = _loginRes$data2.msg, result = _loginRes$data2.result;

                if (code === 1) {
                  router.push("/wxlogin?haslogin=1&key=".concat(result, "&redirect_url=").concat(encodeURIComponent(getAuthRedirectUrl(route.query))));
                } else {
                  ElMessage({
                    message: msg,
                    type: 'error'
                  });
                }

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function goBind() {
        return _ref8.apply(this, arguments);
      };
    }(); // 登录


    var submitForm = function submitForm(formEl) {
      if (!formEl) return;
      formEl.validate(function (valid) {
        if (!valid) {
          return false;
        }

        if (!formState.agreementChecked) {
          ElMessage({
            message: loginTip.checkAgreement,
            type: 'error'
          });
          return false;
        }

        forceBind ? goBind() : register();
      });
    };

    var goLogin = function goLogin() {
      router.push("/login".concat(getUrlQuery(route.query)));
    }; // 切换密码显示


    var togglePasswordType = function togglePasswordType() {
      passwordType.value = passwordType.value === 'password' ? 'text' : 'password';
    }; // 切换密码显示


    var toggleRepeatPasswordType = function toggleRepeatPasswordType() {
      repeatPasswordType.value = repeatPasswordType.value === 'password' ? 'text' : 'password';
    };

    var sendVerifyCode = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _data$data;

        var data, timer;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return UserService.sendRegisterVerifyCode({
                  send_type: 'EMAIL',
                  receive_address: formState.name.trim()
                });

              case 2:
                data = _context9.sent;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  ElMessage({
                    message: loginTip.sendCodeSuccess,
                    type: 'success'
                  });
                  hasSentCode.value = true;
                  timer = window.setInterval(function () {
                    if (verifyCodeTimer.value > 0) {
                      verifyCodeTimer.value = verifyCodeTimer.value - 1;
                    } else {
                      clearInterval(timer);
                      hasSentCode.value = false;
                      verifyCodeTimer.value = 60;
                    }
                  }, 1000);
                } else {
                  ElMessage({
                    showClose: true,
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function sendVerifyCode() {
        return _ref9.apply(this, arguments);
      };
    }();

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
      var _route$query3, _route$query3$bind_co, bind_code, _route$query3$corpInv, corpInvitationCode, _route$query3$email, email, _route$query3$corpora, corporation;

      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              // eslint-disable-next-line @typescript-eslint/naming-convention
              _route$query3 = route.query, _route$query3$bind_co = _route$query3.bind_code, bind_code = _route$query3$bind_co === void 0 ? '' : _route$query3$bind_co, _route$query3$corpInv = _route$query3.corpInvitationCode, corpInvitationCode = _route$query3$corpInv === void 0 ? '' : _route$query3$corpInv, _route$query3$email = _route$query3.email, email = _route$query3$email === void 0 ? '' : _route$query3$email, _route$query3$corpora = _route$query3.corporation, corporation = _route$query3$corpora === void 0 ? '' : _route$query3$corpora;
              bindCode.value = "".concat(bind_code);
              corpInviteCode.value = "".concat(corpInvitationCode);

              if (corpInviteCode.value) {
                corpName.value = (corporation === null || corporation === void 0 ? void 0 : corporation.toString()) || '';
                formState.name = (email === null || email === void 0 ? void 0 : email.toString()) || '';
                rules.fullName = [{
                  validator: validateFullName,
                  trigger: 'blur'
                }];
              } else {
                rules.verifyCode = [{
                  validator: validateVerifyCode,
                  trigger: 'blur'
                }];
              }

            case 4:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    })));
    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_tooltip = _resolveComponent("el-tooltip");

      var _component_el_checkbox = _resolveComponent("el-checkbox");

      var _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, corpInviteCode.value ? (_openBlock(), _createElementBlock("p", _hoisted_5, [_hoisted_6, _createElementVNode("span", null, _toDisplayString(corpName.value), 1), _hoisted_7])) : _createCommentVNode("", true), _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: _unref(formState),
        "status-icon": "",
        rules: rules,
        "label-width": 0,
        class: "custom-form",
        name: "custom-validation"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form_item, {
            label: "",
            prop: "name"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: _unref(formState).name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(formState).name = $event;
                }),
                class: "custom-input",
                autocomplete: "off",
                placeholder: "注册邮箱",
                disabled: !!corpInviteCode.value
              }, null, 8, ["modelValue", "disabled"])];
            }),
            _: 1
          }), corpInviteCode.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "",
            prop: "fullName"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: _unref(formState).fullName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return _unref(formState).fullName = $event;
                }),
                class: "custom-input",
                autocomplete: "off",
                placeholder: "真实姓名"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), !corpInviteCode.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "",
            prop: "verifyCode",
            class: "verify-code-form"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: _unref(formState).verifyCode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return _unref(formState).verifyCode = $event;
                }),
                class: "custom-input verify-code-input",
                autocomplete: "off",
                placeholder: "验证码"
              }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
                class: "send-code",
                type: "primary",
                disabled: !_unref(formState).name || _unref(checkEmail)(_unref(formState).name.trim()) || !!nameError.value || hasSentCode.value,
                onClick: sendVerifyCode
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(hasSentCode.value ? verifyCodeTimer.value + ' 秒后重试' : '发送验证码'), 1)];
                }),
                _: 1
              }, 8, ["disabled"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "",
            prop: "password"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_tooltip, {
                trigger: "click",
                effect: "light",
                placement: "right-start",
                teleported: false,
                "popper-class": "register-password-tooltip"
              }, {
                content: _withCtx(function () {
                  return [_createElementVNode("ul", _hoisted_8, [_createElementVNode("li", {
                    class: _normalizeClass({
                      valid: validatePasswordStatus().moreThen8
                    })
                  }, _hoisted_11, 2), _createElementVNode("li", {
                    class: _normalizeClass({
                      valid: validatePasswordStatus().charValid
                    })
                  }, _hoisted_14, 2)])];
                }),
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    class: "custom-input",
                    modelValue: _unref(formState).password,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                      return _unref(formState).password = $event;
                    }),
                    type: passwordType.value,
                    autocomplete: "off",
                    placeholder: "设置密码"
                  }, null, 8, ["modelValue", "type"])];
                }),
                _: 1
              }), _createElementVNode("i", {
                class: _normalizeClass(["iconfont password-type", passwordType.value === 'text' ? 'iconbrowse' : 'iconbrowse-off']),
                onClick: togglePasswordType
              }, null, 2)];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "",
            prop: "repeatPassword"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                class: "custom-input",
                modelValue: _unref(formState).repeatPassword,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                  return _unref(formState).repeatPassword = $event;
                }),
                type: repeatPasswordType.value,
                autocomplete: "off",
                placeholder: "确认密码"
              }, null, 8, ["modelValue", "type"]), _createElementVNode("i", {
                class: _normalizeClass(["iconfont password-type", repeatPasswordType.value === 'text' ? 'iconbrowse' : 'iconbrowse-off']),
                onClick: toggleRepeatPasswordType
              }, null, 2)];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "",
            prop: "phone"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                class: "custom-input phone-input",
                modelValue: _unref(formState).phone,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                  return _unref(formState).phone = $event;
                }),
                autocomplete: "off",
                placeholder: "手机号"
              }, null, 8, ["modelValue"]), _hoisted_15, !phoneError.value ? (_openBlock(), _createElementBlock("p", _hoisted_16, " 选填 ")) : _createCommentVNode("", true)];
            }),
            _: 1
          }), _unref(serviceProtocol) || _unref(privacyProtocol) ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "",
            class: "agreement-form-item"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_checkbox, {
                modelValue: _unref(formState).agreementChecked,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                  return _unref(formState).agreementChecked = $event;
                }),
                class: "custom-checkbox"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_17, _unref(serviceProtocol) ? (_openBlock(), _createElementBlock("span", _hoisted_18, [_createElementVNode("a", {
                    href: _unref(serviceProtocol),
                    target: "_blank"
                  }, " 腾讯灯塔增长平台服务协议", 8, _hoisted_19), _hoisted_20])) : _createCommentVNode("", true), _unref(privacyProtocol) ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: _unref(privacyProtocol),
                    target: "_blank"
                  }, " 隐私声明 ", 8, _hoisted_21)) : _createCommentVNode("", true)];
                }),
                _: 1
              }, 8, ["modelValue"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                class: "submit-button",
                type: "primary",
                onClick: _cache[7] || (_cache[7] = function ($event) {
                  return submitForm(formRef.value);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref(submitText)), 1)];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["model"])]), !corpInviteCode.value ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_hoisted_23, _createVNode(_component_el_button, {
        type: "text",
        class: "link-button",
        onClick: goLogin
      }, {
        default: _withCtx(function () {
          return [_hoisted_24];
        }),
        _: 1
      })])) : _createCommentVNode("", true)])]);
    };
  }
});